import React, { memo, useContext, useEffect, useState } from 'react';
import useClickStreamEvent from '../../utils/clickstream/useClickStreamEvent';
import { configuratorContext } from '../../context/ConfiguratorContext';

type VKAdProps = {
  slotId: string;
  maxWidth: string;
  maxHeight: string;
  className?: string;
  isSideBanner?: boolean;
};

const VKAd = memo(function VKAd({
  slotId,
  maxWidth,
  maxHeight,
  className,
  isSideBanner = true,
}: VKAdProps) {
  const { sendEvent } = useClickStreamEvent();
  const { banners } = useContext(configuratorContext);
  const [domLoaded, setDomLoaded] = useState(false);
  const vkAbTestLabel = banners?.otvety_test_vk_ad?.groupName;
  const isVkLabelTarget = vkAbTestLabel === 'target';
  const positionBanner = isSideBanner ? 'side' : 'top';

  useEffect(() => {
    setDomLoaded(true);
    sendEvent({
      eventType: 'display',
      eventInfo: `otvety_vk_ad_${positionBanner}_${vkAbTestLabel}`,
    });
  }, [vkAbTestLabel]);

  const clickVkAdHandler = () => {
    sendEvent({
      eventType: 'click',
      eventInfo: `otvety_vk_ad_${positionBanner}_${vkAbTestLabel}`,
    });
  };

  return (
    <>
      {domLoaded && isVkLabelTarget && (
        <div className={className}>
          <ins
            className="mrg-tag"
            style={{
              maxWidth,
              maxHeight,
              textDecoration: 'none',
            }}
            data-ad-client={`ad-${slotId}`}
            data-ad-slot={slotId}
            data-ad-query="a=17"
            onClick={clickVkAdHandler}
          ></ins>
          <script>(MRGtag = window.MRGtag || []).push({})</script>
        </div>
      )}
    </>
  );
});

export default VKAd;
